import { Col, Spinner2 } from 'components';

const List = ({ Header, Items, loading, Footer, maxTableHeight, minTableHeight }) => {
  return (
    <Col wid="100%" start>
      <table style={{ width: '100%', borderSpacing: 0 }}>
        <tbody
          style={
            maxTableHeight && minTableHeight
              ? {
                  maxHeight: maxTableHeight,
                  minHeight: minTableHeight,
                  display: 'block',
                  overflowY: 'scroll'
                }
              : {}
          }
        >
          <tr style={{ position: 'sticky', top: 0, backgroundColor: '#fff', zIndex: 1 }}>
            {Header && <Header />}
          </tr>

          {Items && Items()}
        </tbody>
      </table>
      {Footer && Footer()}

      {loading && (
        <Col wid="calc(100vw - 200px)" marg="24px 0" centerAll noFlex>
          <Spinner2 />
        </Col>
      )}
    </Col>
  );
};

export default List;
